import React from 'react'

import { ThemeProvider, createMuiTheme } from '@material-ui/core/styles';

import { RegistroEstudianteScreen } from './components/estudiante/RegistroEstudianteScreen';
import { RegistroPadreScreen } from './components/padre/RegistroPadreScreen';
import { RegistroAdultoScreen } from './components/padre/RegistroAdultoScreen';

import { makeStyles } from '@material-ui/core/styles';
// import { ThemeProvider } from '@material-ui/styles';
// import { theme } from './styles/setTheme';
import { useSelector } from 'react-redux';
import { FormatoScreen } from './components/formato/FormatoScreen';

import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import InfoRoundedIcon from '@material-ui/icons/InfoRounded';
// import './styles/fonts.scss'
// import './index.css';
import './styles/main.scss';
import { InformacionBasicaScreen } from './components/cabecera/InformacionBasicaScreen';
import { updateInfoBasica } from './redux/actions/informacionBasicaActions';

import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import { isBrowser } from "react-device-detect";
import { BrowserRouter as Router, Route, useLocation } from 'react-router-dom';

import { 
    Button
} from '@material-ui/core'
import { ConfirmControl } from '../src/controls/Confirmacion'

const { detect } = require('detect-browser');


const theme = createMuiTheme({
    typography: {
        fontFamily: [
            'HelveticaNeueLT Std Cn'
        ],
    },});

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        "& .MuiCardHeader-avatar": {
            marginRight: '0px'
        }
    },
    avatar: {
        backgroundColor: theme.palette.primary.main,
    },
    headerTitle: {
        fontSize: '16px !important',
        fontWeight: 'bold !important',
        // fontFamily:'HelveticaBold',
    },
}));



export const App = () => {
    return (
        <Router>
        <div>
            <Route path="/" component={ComponenteConTipo} />
        </div>
        </Router>
    );
}


function ComponenteConTipo() {
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const tipo = searchParams.get('tipo');

    localStorage.setItem('tipo_persona_registro', tipo);

    const classes = useStyles();

    const padre = useSelector( state => state.padre )
    const informacion_basica = useSelector( state => state.informacion_basica )

    const browser = detect();
    

    // switch (browser && browser.name) {
    //     case 'chrome':
    //     case 'firefox':
    //         console.log('supported');
    //         break;
    //     case 'edge':
    //         console.log('kinda ok');
    //         break;
    //     default:
    //         console.log('not supported');
    // }

    // if (browser) {
    //     console.log(browser.name, browser.version, browser.os);
    // }


    
    const [open, setOpen] = React.useState(false);

    const handleClickListItem = () => {
        setOpen(true);
    };
    const handleReload = () => {
        // history.push('/')
        // history.replace('/')

        localStorage.removeItem('tipo_envio');
        localStorage.removeItem('nombre_formato_vee');
        localStorage.removeItem('id_formato_selected');
        localStorage.removeItem('arr_id_formato_registrados');
        
        window.location.reload();
    }

    const handleClose = (newValue) => {
        setOpen(false);
    };


    return (
        <>
            <ThemeProvider theme={ theme }>
                <div className={ classes.root }>
                    <div>
                        <Card style={{ padding: '1px 1px', textAlign: 'center'}}>
                            {/* <CardHeader style={{ padding: '0px'}}
                                // <Avatar aria-label="recipe" className={classes.avatar}>
                                //     CGR
                                // </Avatar>
                                // <IconButton aria-label="settings">
                                //     <InfoRoundedIcon />
                                // </IconButton>


                                // avatar={
                                // <IconButton aria-label="share" style={{marginRight: '0px'}}>
                                //     <InfoRoundedIcon color="secondary"/>
                                // </IconButton>
                                // }
                                title='PROGRAMA AUDITORES JUVENILES "BUEN INICIO DE AÑO ESCOLAR"'
                                classes={{
                                    title: classes.headerTitle
                                }} 
                                subheader='Base legal:
                                · RM N° 086-2023-MINEDU, "Relación de materiales educativos pata la Educación Básica correspondiente a la dotación 2023".
                                · RM N° 474-2022-MINEDU, NT "Disposiciones para la prestación del servicio educativo en las instituciones y programas educativos de la educación básica para el año 2023".
                                · RVM N° 010-2022-MINEDU, actualización de la NT denominada "Criterios Generales de Diseño para Infraestructura Educativa".
                                · RM N° 075-2023-VIVIENDA, que modifica la NT A.120, Accesibilidad Universal en Edificaciones del Reglamento Nacional de Edificaciones.
                                · RM N°525-2009 - Directiva Sanitaria N° 28-MINSA/DIGESA V.01'
                            /> */}





                            {/* LÓGICA: UNA ÚNICA VEEDURÍA */}
                           <CardContent>
                                <Typography gutterBottom variant="h6" component="div">
                                    PROGRAMA AUDITORES JUVENILES
                                    <br/>
                                    VEEDURÍA ESCOLAR: ORGANIZACIÓN Y FUNCIONAMIENTO DE ESPACIOS EDUCATIVOS​
                                </Typography>
 


<table align='left'>
<tr>
    <th style={{textAlign: 'left'}}>BASE LEGAL:</th>
  </tr>


<table align='center' >
  
  <tr style={{textAlign: 'left'}}>
- Ley N° 28044, Ley General de Educación y su Reglamento, aprobado por Decreto Supremo Nº 011-2012-ED.  <br/>
- D.N. N° 011-2006-VIVIENDA, Reglamento Nacional de Edificaciones.  <br/>
- R.V.M. N° 068-2025-MINEDU, Norma Técnica denominada "Criterios Generales de Diseño para la Infraestructura Educativa".  <br/>
- R.V.M. N° 036-2024-MINEDU, que aprueba la Norma Técnica denominada “Disposiciones para la organización y funcionamiento pedagógico de espacios educativos de Educación Básica Regular.  <br/> 
- R.V.M. N° 062-2021-MINEDU Documento normativo que aprueba “Disposiciones para la organización e implementación del Plan Lector en las Instituciones Educativas y Programas educativos de la Educación Básica”.  <br/>
- R.V.V. N° 234-2021-MINEDU, que aprueba los “Lineamientos para la incorporación de tecnologías digitales en la educación básica”.  <br/>   
- Resolución de Secretaría de Gestión del Riesgo de Desastres N° 001-2025-PCM/SGRD, que aprueba la ejecución de simulacros y simulaciones para los años 2025-2027.  <br/>
- Resolución de Secretaría General N° 302-2019-MINEDU de 24.12.2019 – Norma Técnica denominada “Disposiciones para la implementación de la Gestión del Riesgo de Emergencias y Desastres en el Sector Educación.  <br/>
 

 </tr>
  
</table>                            
</table> 




                  
</CardContent>

                           






                            {/* {
                                (tipo == 'estudiante')
                                ?
                                    <CardContent>
                                        <Typography gutterBottom variant="h6" component="div">
                                            PROGRAMA AUDITORES JUVENILES
                                        </Typography>
                                    </CardContent>
                                :
                                    <CardContent>
                                        <Typography gutterBottom variant="h6" component="div">
                                            PROGRAMA AUDITORES JUVENILES
                                            <br/>
                                            VEEDURÍA ESCOLAR "PROGRAMA DE MANTENIMIENTO EN LAS INSTITUCIONES EDUCATIVAS - 2024"
                                        </Typography>
                                        <Typography variant="body2" color="text.secondary" style={{color: 'gray'}}>
                                            - Ley N° 28044 - Ley General de Educación<br/>
                                            - D.S N° 011-2012-ED, Reglamento de la Ley N° 28044, Ley General de Educación<br/>
                                            - DS Nº 004-2014-MINEDU, Programa Nacional de Infraestructura Educativa (PRONIED)<br/>
                                            - RM N° 557-2020-MINEDU, NT "Disposiciones generales para la ejecución de mantenimiento y acondicionamiento de infraestructura educativa bajo la modalidad de subvenciones"<br/>
                                            - RM Nº 679-2023-MINEDU,NT "Disposiciones para la ejecución del Programa de Mantenimiento para el año 2024"<br/>
                                            - RVM N° 010-2022-MINEDU, NT "Criterios Generales de Diseño para Infraestructura Educativa"<br/>
                                            - Ley Nº 31953 -Ley de Presupuesto del Sector Público para el Año Fiscal 2024.
                                            - Resolución Directoral Ejecutiva N° 000002-2024-MINEDU-VMGI-PRONIED-DE, mediante la cual se aprueba el "Listado de Locales Educativos beneficiarios del Programa de Mantenimiento para el año 2024".
                                        </Typography>
                                    </CardContent>
                            } */}
                        </Card>
                    </div>




                    {
                                                isBrowser
                                                ?
                                                    <div style={{ display: 'flex', width: '100%' }}>
        
                                                        <div style={{ display: 'flex', flexGrow: 1 }}>
        
                                                            <Button size="large" className={ classes.buttonStyle }
                                                            style={ { position: 'left', marginBottom: '10px' } }
                                                            variant="outlined"
                                                            color="secondary"
                                                            onClick={ handleClickListItem }>
                                                                Volver a cargar
                                                            </Button>
                                                        </div>
                                                        <div style={{ display: 'inline-flex', flex: "0 0 auto" }}>
                                                            
                                                        </div>
                                                    </div>
                                                :
                                                    <div style={{ width: '100%' }}>
                                                        <Button size="small" className={ classes.buttonStyle }
                                                            style={{ width: '100%', marginBottom: '10px' }}
                                                            variant="outlined"
                                                            color="secondary"
                                                            onClick={ handleClickListItem }>
                                                                Volver a cargar
                                                            </Button>

                                                    </div>
                                            }


                    <div>
                        {
                            (tipo == 'estudiante') && <RegistroPadreScreen/>
                        }
                        {
                            (tipo == 'adulto') && <InformacionBasicaScreen/>
                        }
                        {
                            (informacion_basica.cargo === '001' || informacion_basica.cargo === '002' || informacion_basica.cargo === '003' || informacion_basica.cargo === '004')
                            &&
                                <RegistroAdultoScreen/>
                        }



                        <ConfirmControl
                            classes={{
                                paper: classes.paper,
                            }}
                            id="menu"
                            keepMounted
                            open={ open }
                            // onSubmit={ handleSubmit }
                            onSubmit={ handleReload }
                            onClose={ handleClose }
                            dni={ "" }
                            alerta={ false }
                            nombre={ "" } />

                        {
                            (padre.nombre_completo?.length > 0 || padre.isValidated)
                            ?
                                <RegistroEstudianteScreen/>
                            :
                                null
                        }
                    </div>
                </div>
            </ThemeProvider>
        </>
    )
}


